"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rowToCsv = exports.rowToText = exports.rowToMjml = void 0;

var _base = require("./common/base");

var _formatDefinition = require("./common/formatDefinition");

var rowToMjml = function rowToMjml(item, blockRenderer, isTopLevelNode) {
  var items = '';
  (item.children || []).forEach(function (x) {
    items += blockRenderer(x, blockRenderer, false);
  });
  item.properties.children = items;
  return (0, _base.toMjml)('mj-section', item.properties, _formatDefinition.EDIE_PROPS[_formatDefinition.EDIE_BLOCK_TYPE.ROW]);
};

exports.rowToMjml = rowToMjml;

var rowToText = function rowToText(item, blockRenderer, isTopLevelNode) {
  var result = '';
  (item.children || []).forEach(function (x) {
    // Note: All children of a row are NOT top level elements
    result += blockRenderer(x, blockRenderer, false);
  });
  return result + '\r\n';
};

exports.rowToText = rowToText;

var rowToCsv = function rowToCsv(item, blockRenderer, isTopLevelNode, templateMetadata) {
  var result = '';
  (item.children || []).forEach(function (x, index) {
    // Note: All children of a row are NOT top level elements
    result += blockRenderer(x, blockRenderer, false, templateMetadata);
    result += index === item.children.length - 1 ? '' : templateMetadata.xCsvSeparator;
  });
  return result + '\n';
};

exports.rowToCsv = rowToCsv;